import { render, staticRenderFns } from "./ProductionBarcodeReader.vue?vue&type=template&id=59818281&scoped=true&"
import script from "./ProductionBarcodeReader.vue?vue&type=script&lang=js&"
export * from "./ProductionBarcodeReader.vue?vue&type=script&lang=js&"
import style0 from "./ProductionBarcodeReader.vue?vue&type=style&index=0&id=59818281&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59818281",
  null
  
)

export default component.exports